// TODO use the API to get the list of markets

// @ts-expect-error - We're not using any of these right now, but will in future
const ALL_CANADIAN_MARKETS = [
  'toronto',
  'ottawa',
  'kwc',
  'hamilton',
  'calgary',
  'vancouver',
];

const CALIFORNIA_MARKETS = [
  'bay area',
  'san diego',
  'los angeles',
  'sacramento',
];

// @ts-expect-error - We're not using any of these right now, but will in future
const ALL_US_MARKETS = [
  ...CALIFORNIA_MARKETS,
  'chicago',
  'denver',
  'austin',
  'dallas',
  'houston',
  'miami',
  'phoenix',
  'new york city',
  'las vegas',
  'seattle',
  'detroit',
];

// Experiment Documentation: https://www.notion.so/opencare/Creating-an-Experiment-188133bf427f418c9de367ef3586db88?pvs=4

export const VARIANTS = Object.freeze({
  CONTROL: 'CONTROL',
  VARIANT: 'VARIANT',
});

export interface Experiment {
  name: string;
  markets?: string[];
}

export enum ExperimentName {
  CHECKOUT_REDESIGN = 'CHECKOUT_REDESIGN',
}

export enum ExperimentVariantType {
  CONTROL = 'CONTROL',
  VARIANT = 'VARIANT',
}

export interface AssignedExperiment {
  name: ExperimentName;
  variant: {
    type: ExperimentVariantType;
    variantNumber: string;
  };
}

/**
 * name: Short name of the experiment. Must match the name in ExperimentConfigs in the API
 * markets: List of markets where the experiment should be run
 */
export const EXPERIMENTS: Record<ExperimentName, Experiment> = {
  [ExperimentName.CHECKOUT_REDESIGN]: {
    name: 'checkout-redesign',
  },
};

